// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles__separator___20Avh","container":"styles__container___1jkmx"};